var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row match-height"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed"}},[_c('vs-tab',{staticClass:"mt-2",attrs:{"label":_vm.$t('DocumentsType')}},[_c('documents')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }